export const formatStringArray = (arr: string[]): string => `[${arr.map(d => `$${d}`).join(',')}]`;

export const formatRegExpArray = (fieldName: string, arr: Array<string>): string =>
  arr.map(d => `data.${fieldName}==/"${d}"`).join('|');

export const partialDateToString = (p?: PartialDate): string | undefined => {
  return p
    ?.filter(n => {
      return Number.isInteger(n);
    })
    .join(',');
};
